module.exports = __webpack_public_path__ + "f76ccb0bf1200004103cd8a6272b5c4b.svg";